module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate24.6cd96c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate24.png
// module id = 760
// module chunks = 0